<!--
 * @Author: gaoxueting
 * @Date: 2020-06-03 17:55:51
 * @LastEditTime: 2020-08-14 16:34:11
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/modules/cloudmgt/env/components/acl/detail.vue
-->
<template>
    <div class="acldetail layout-rctable-container">
        <DetailInfo title="基本信息"
                    col=2
                    style="margin-bottom: 15px; background: #fff;">
            <Item label="名称"
                  :value="baseInfo.name" />
            <Item label="状态">
                <span style="margin-top:5px;">
                    <statusview :state="Boolean(baseInfo.adminStateUp)"
                                :stateName="baseInfo.adminStateUp=== 'true' ? this.$t('开启') : this.$t('关闭')"></statusview>
                </span>
            </Item>
            <Item label="ID"
                  :value="$t(baseInfo.uuid)">
            </Item>
            <Item label="描述"
                  :value="baseInfo.description" />
        </DetailInfo>
    </div>
</template>
<script>
// import API from '@/service/api.js'
import { DetailInfo, Item } from '@c/basic/rcdetailinfo'
export default {
    name: 'aclinfo',
    props: ['id', 'baseInfo'],
    components: {
        DetailInfo,
        Item
    },
    data: function () {
        return {
            envType: this.$route.query.envType
        }
    },
    created () {
    },
    methods: {
    }
}
</script>
<style lang="less">
#app .acldetail .info-pack > .title {
    border: none;
}
.acldetail {
    position: relative;
    background: #fff;
    .edit-button {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        color: #808080;
        z-index: 10;
    }
    .detailInfo-pack {
        padding: 20px 11px 20px 11px;
        & > .title {
            height: 12px !important;
            line-height: 12px !important;
            margin-bottom: 6px !important;
        }
        .label {
            color: #808080;
        }
        ul li {
            color: #333333;
        }
        .status-div {
            min-width: 48px !important;
        }
        .icon-edit1 {
            color: #808080;
        }
    }
}
</style>
